/**
 * Vue Meta
 */
import Meta from 'vue-meta';

export const plugin = {
    name: 'meta',

    install (Vue) {
        Vue.use(Meta, {
            // optional pluginOptions
            refreshOnceOnNavigation: true
          });
    }
};

export default plugin;
